import { render, staticRenderFns } from "./RelatedTasks.vue?vue&type=template&id=49b6d544&"
import script from "./RelatedTasks.vue?vue&type=script&lang=js&"
export * from "./RelatedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports